import { render, staticRenderFns } from "./magnifyGlass_small.vue?vue&type=template&id=638b967a&scoped=true&"
import script from "./magnifyGlass_small.vue?vue&type=script&lang=js&"
export * from "./magnifyGlass_small.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638b967a",
  null
  
)

export default component.exports